var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"idtr-block idtr-intro"},[_vm._v(_vm._s(_vm.text.intro))])
}
var staticRenderFns = []

export { render, staticRenderFns }